// src/services/authConfig.js or src/config/oktaAuth.js
import { OktaAuth } from '@okta/okta-auth-js';
import { toRelativeUrl } from '@okta/okta-auth-js';

const getRedirectUri = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin + '/authorization-code/callback';
  }
  return 'http://localhost:3000/authorization-code/callback';
};

export const oktaConfig = {
  issuer: 'https://bvp.okta.com',
  clientId: '0oa25gr6el5imyLNd0h8',
  redirectUri: getRedirectUri(),
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true
};

export const oktaAuth = new OktaAuth(oktaConfig);

export const onAuthRequired = () => {
  oktaAuth.signInWithRedirect();
};

export const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.replace(
    toRelativeUrl(originalUri || '/', window.location.origin)
  );
};